module.exports = __webpack_public_path__ + "img/LNB_collection.3da6a2d0.svg";